// 技术生态-研究院
<template>
  <div class="ecological-institute">
    <div class="ecological-institute-info">
      <div class="ecological-institute-info-title">研究院</div>
      <div class="ecological-institute-info-content">
        我们的核心算法体系由斯梅尔数学与计算研究院与公司自研算法实验室共同驱动，将学术研究转化为可实际应用的算法，紧密结合产业需求开展算法开发与工程化验证，持续产出原创算法成果。
      </div>
    </div>
    <van-tabs v-model="active" class="tabs" @click="handleTabChange"  id="tabs" :class="{'fixedTabs': fixedTabs}">
      <van-tab v-for="item in tabs" :key="item" :title="`${item}`" />
    </van-tabs>
    <a name="smale" id="smale"><Smale id="tab-smale"/></a>
    <a name="cooperation" id="cooperation"><Cooperation /></a>
  </div>
</template>
<script>
import Smale from './smale.vue'
import Cooperation from './cooperation.vue'
export default {
  name: 'ecological-institute',
  components: { Smale, Cooperation },
  data() {
    return {
      tabs: ['斯梅尔研究院', '高校合作'],
      active: 0,
      refs: [
        'smale',
        'cooperation'
      ],
      fixedTabs: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.tabScroll)
  },
  methods: {
    handleTabChange(e) {
      if (e == 0) {
        document.documentElement.scrollTop = this.fixedTabs
        ?
        632 * this.$el.clientWidth / 750
        :
        document.getElementById([this.refs[e]]).offsetTop - 190 * this.$el.clientWidth / 750;
      } else {
        document.documentElement.scrollTop = document.getElementById([this.refs[e]]).offsetTop - 190 * this.$el.clientWidth / 750;
      }  
    },
    tabScroll() {
      const tab2Top = document.getElementById('researchCenter').offsetTop - 1 - 190 * this.$el.clientWidth / 750;
      const tab3Top = document.getElementById('cooperation').offsetTop - 1 - 190 * this.$el.clientWidth / 750;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.fixedTabs = scrollTop > 632 * this.$el.clientWidth / 750;
      if (tab2Top <= scrollTop && tab3Top > scrollTop) {
        this.active = 1;
      } else if (tab3Top <= scrollTop) {
        this.active = 2;
      } else {
        this.active = 0;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.tabScroll)
  }
}
</script>
<style lang="less" scoped>
.ecological-institute {
  width: 100%;
  padding: 96px 0px 0px;
  .ecological-institute-info {
    height: 536px;
    background: url('../../../../static/img/ecological/ecological_institute_bg.png') no-repeat 0 0 / 100%;
    overflow: hidden;
    text-align: center;
    padding: 48px 68px;
    .ecological-institute-info-title {
      font-size: 44px;
      color: #08204D;
      line-height: 60px;
    }
    .ecological-institute-info-content {
      margin-top: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #08204D;
      line-height: 40px;
      text-align: left;
    }
  }
  .tabs {
    height: 94px;
    z-index: 1;
    /deep/.van-tabs__wrap {
      height: 94px;
      .van-tab__text {
        height: 100%;
        font-size: 26px;
        line-height: 94px;
        color: #08204D;
      }
    }
    /deep/.van-tab--active >span {
      color: #2632FA !important;
    }
    /deep/.van-tabs__line {
      background-color: #2632FA;
    }
    /deep/.van-tab {
      flex: none !important;
      margin: 0 20px;
    }
    /deep/.van-tab:first-child {
      flex: none !important;
      margin: 0 20px 0 40px;
    }
    /deep/.van-tab:last-child {
      flex: none !important;
      margin: 0 40px 0 20px;
    }
  }
  .fixedTabs {
    position: fixed;
    top: 96px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/ecological/institute/index.vue